import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Term/Condition: A contractual requirement governing the use of research funds and subaward compliance.',
    name: 'Subaward Terms & Conditions',
    partialId: PartialId.Standard.create('subaward_tcs'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
